import { RawCarData } from 'api/cars'
import { replacePlaceholders } from 'lib/placeholders'
import { SpecificationProps } from 'ui/card/components/Specifications'
import { EcomIconsId } from 'ui/icon/types'

import { CarViewSettings } from '../types'

/**
 * Проверяет, есть ли среди строковых значений значение, содержащее подстроку
 * @param terms
 * @param string
 */
const checkAmong = (terms: string[], string: string): boolean => {
  return terms.some((term) => string.toLowerCase().includes(term))
}

/**
 * Возращает иконку для спецификации авто
 * @param specificationName
 * @param specificationValue
 */
const getSpecificationIcon = (specificationName: string, specificationValue: string): EcomIconsId | null => {
  const getWheelDriveIcon = (specificationName: string): EcomIconsId => {
    if (checkAmong(['полн', 'пп'], specificationName)) return 'wheel-full'
    if (checkAmong(['зад, зп'], specificationName)) return 'wheel-back'
    return 'wheel-front'
  }
  if (specificationName === 'engine') return 'engine-2'
  if (specificationName === 'transmission')
    return checkAmong(['акпп', 'автомат', 'авто', 'вариат', 'робот'], specificationValue)
      ? 'transmission-a'
      : 'transmission-m'
  if (specificationName === 'fuel') return 'fuel'
  if (specificationName === 'district') return 'placeholder'
  if (specificationName === 'wheelDrive') return getWheelDriveIcon(specificationValue)
  if (specificationName === 'mileage') return 'mileage'
  if (specificationName === 'owners') return 'user'
  if (specificationName === 'acceleration') return 'acceleration'
  return null
}
/**
 * Создаёт список спецификаций автомобиля
 * @param car
 * @param carViewSettings
 * todo: техдолг, перенести на бэк
 */
export const createSpecifications = (car: RawCarData, carViewSettings: CarViewSettings): SpecificationProps[] => {
  return Object.entries(carViewSettings.specifications)
    .map((entry) => {
      const text = replacePlaceholders(entry[1], car.placeholders)
      return {
        icon: getSpecificationIcon(entry[0], text) ?? undefined,
        text
      }
    })
    .filter((spec) => spec.text.length)
}
